var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99925 3.67388C9.1433 3.67388 10.2222 4.11615 11.0364 4.91957L13.616 2.30369C12.1097 0.817971 10.1148 0 7.99925 0C4.85272 0 2.12575 1.82673 0.820312 4.47506L3.8186 6.88925C4.31034 5.04042 5.99788 3.67415 7.99897 3.67415L7.99925 3.67388Z",
    fill: "#EC3E3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67381 7.99994C3.67381 7.61585 3.72471 7.24351 3.81898 6.8888L0.82069 4.47461C0.295941 5.53875 0 6.73522 0 7.99994C0 9.43531 0.381814 10.7826 1.04642 11.9485L3.94877 9.51727C3.77143 9.04478 3.67353 8.53369 3.67353 8.00022L3.67381 7.99994Z",
    fill: "#FDC83A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 7.99919V6.16211H7.91797V9.83626H11.9165C11.5456 10.624 10.9423 11.2806 10.1974 11.722L12.8393 14.3642C14.7582 12.9014 15.9998 10.593 15.9998 7.99919Z",
    fill: "#4787F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9998 12.3268C6.14808 12.3268 4.56516 11.1569 3.94922 9.51758L1.04688 11.9488C2.42476 14.3661 5.02417 16.0006 7.9998 16.0006C9.81713 16.0006 11.4943 15.3902 12.8389 14.3653L10.197 11.7231C9.55223 12.1052 8.80203 12.3268 7.9998 12.3268Z",
    fill: "#31A950"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.0352a02c.svg";
export { ForwardRef as ReactComponent };